<script lang="ts">
  import { onMount } from 'svelte';
  import { getCookie, getIframeUrl, xhrPostCall } from './services/Helper.service';
  import { analytics_api } from 'common/services/EnvironmentService';

  onMount(() => {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });
    let sourceValue = cookie['gk_utm_source'] || cookie['_shopify_sa_p'] ;
    let _fbp = cookie['_fbp'];
    let _fbc = cookie['_fbc'];
    let shopifySessionId = cookie['_shopify_s'] || null;
    let shopify_landing_page = cookie['gk_landing_page'] || '/';
    let shopify_orig_referrer = cookie['gk_orig_referrer'] || 'blank';
    let sa_shopify_y = cookie['_shopify_y'] || null;
    let sa_shopify_t = cookie['_shopify_sa_t'] || null;
    let sa_shopify_p = cookie['gk_utm_source'] ||  cookie['_shopify_sa_p'] || null;
    let sa_localization = cookie['localization'] || null;
    let sessionId = localStorage.getItem('gokwik-sessionID') || getCookie('gokwik-sessionID');
    let eventBody: any = {
      shopifySessionId,
      _fbc,
      _fbp,
      landing_page: shopify_landing_page,
      orig_referrer: shopify_orig_referrer,
      sa_shopify_y,
      sa_shopify_t,
      sa_shopify_p,
      sa_localization,
      domain_userid: cookie['SP_DUID'] || '',
      timestamp: Date.now(),
      userAgent: navigator.userAgent,
      name: 'loading_screen_shown',
      eventType: 'development',
      type: 'event',
    };
    if (sessionId) {
      eventBody.requestId = sessionId;
      eventBody.sessionId = sessionId;
    }
    // @ts-ignore
    if (window?.merchantInfo?.mid) {
      // @ts-ignore
      eventBody.merchantId = window.merchantInfo.mid;
    }
    sourceValue && (eventBody.source = sourceValue);
    // @ts-ignore
    xhrPostCall(analytics_api(window.merchantInfo.environment), eventBody, {});
  });
  const getImageUrl = () => {
    // @ts-ignore
    return `${getIframeUrl(window?.merchantInfo?.environment)}/assets/icons/gk-logo.svg`;
  };
</script>

<div class={'gokwik-preloadComponent'}>
  <div class={'gokwik-spinner'}>
    <p class={'gokwik-pTagCss'}>Hold tight, rolling you smoothly to checkout{@html '&hellip;'}</p>
    <img
      src={`${getIframeUrl(window?.merchantInfo?.environment)}/assets/icons/gokwik_gif.gif`}
      class={'gokwik-gokwikIconCss'}
      id="small-icon"
      alt="gokwik_loading_gif"
    />
    <div class={'gokwik-poweredByCss'}>
      Powered by <img
        src={getImageUrl()}
        style={`
        background-image: url(${getImageUrl()});
        `}
        class={'gokwik-globalImgCss'}
        alt="gokwik_icon"
      />
    </div>
  </div>
</div>
